var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('top-bar'),_c('nav-drawer',{on:{"reset":_vm.onReset}}),_c('page-view'),_c('v-overlay',{staticClass:"text-center",attrs:{"value":_vm.updating,"opacity":".8"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","color":"primary","z-index":"10"}}),_c('v-subheader',[_vm._v(" Verificando updates... ")])],1),_c('toast')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }